import { render, staticRenderFns } from "./StanceWidget.vue?vue&type=template&id=6199a190&scoped=true"
import script from "./StanceWidget.vue?vue&type=script&lang=js"
export * from "./StanceWidget.vue?vue&type=script&lang=js"
import style0 from "./StanceWidget.vue?vue&type=style&index=0&id=6199a190&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199a190",
  null
  
)

export default component.exports